var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { sortByKey } from '@/support/Object';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import DataTable from '@/components/data-table/DataTable';
import { Teacher } from '@/models/Teacher';
import { Subject } from '@/models/Subject';
import { colorHtml, avatarHtml } from '@/support/String';
import { Room } from '@/models/Room';
import { Level } from '@/models/Level';
import { Group } from '@/models/Group';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import { formatDate as format } from '@/support/String';
import { DateTimeslot } from '@/models/DateTimeslot';
import { Event as EventModel } from '@/models/Event';
import { Model as DataModel } from '@/models/Model';
import { DateTime } from 'luxon';
import { whiteAreaIcons, whiteKidIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import { RolesEnum } from '@/items/Roles';
let CreateEventDialog = class CreateEventDialog extends Vue {
    constructor() {
        super(...arguments);
        this.event = null;
        this.visibility = {
            checkboxes: false,
        };
        this.selectedTeachers = [];
        this.selectedAreas = [];
        this.selectedTeacherAreas = [];
        this.selectedTeacherAreaId = [];
        this.selectedTopics = [];
        this.tableSelectedRoom = '';
        this.selectedLevels = [];
        this.selectedGroups = [];
        this.teacherSubjects = [];
        this.userSubjects = [];
        this.isLoading = true;
        this.isDoublePeriod = false;
        this.isMandatoryLevels = false;
        this.isMandatoryGroups = false;
        this.isRoomFull = false;
        this.selectedDoublePeriodDatetimeslot = null;
        this.clearSelects = false;
        this.currentStep = 1;
    }
    get tableOptionsTeachers() {
        return {
            name: {
                singular: this.$tc('group.teacher', 1),
                plural: this.$tc('group.teacher', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            model: new Teacher().filter('is_available_for_datetimeslot', this.datetimeslot ? this.datetimeslot.id || '' : ''),
        };
    }
    get tableOptionsAllAreas() {
        return {
            name: {
                singular: this.$tc('subject.area.title', 1),
                plural: this.$tc('subject.area.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Subject().filter('depth', 0),
        };
    }
    get tableOptionsAllTopics() {
        return {
            name: {
                singular: this.$tc('subject.topic.title', 1),
                plural: this.$tc('subject.topic.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Subject().filter({
                depth: 1,
                parent: this.selectedAreas && this.selectedAreas.length ? this.selectedSubjectAreaId : this.selectedTeacherSubjectAreaId,
            }),
        };
    }
    get selectedSubjectAreaId() {
        if (this.selectedAreas) {
            const areas = this.selectedAreas.map((subject) => {
                return subject.id;
            });
            return areas && areas[0] ? areas[0] : '';
        }
    }
    get selectedTeacherSubjectAreaId() {
        if (this.selectedTeacherAreas) {
            const topics = this.selectedTeacherAreas.map((subject) => {
                return subject.userSubject.subject;
            });
            return topics && topics[0] ? topics[0] : '';
        }
    }
    get tableOptionsRooms() {
        return {
            name: {
                singular: this.$tc('room.title', 1),
                plural: this.$tc('room.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Room().filter('is_available_for_datetimeslot', this.datetimeslot ? this.datetimeslot.id || '' : ''),
        };
    }
    get tableOptionsLevels() {
        return {
            name: {
                singular: this.$tc('level.title', 1),
                plural: this.$tc('level.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Level().include(['users', 'roles']),
        };
    }
    get tableOptionsGroups() {
        return {
            name: {
                singular: this.$tc('group.title', 1),
                plural: this.$tc('group.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Group().include(['users', 'roles']),
        };
    }
    get mergedselectedAreas() {
        const subjects = [];
        if (this.selectedTeacherAreas) {
            this.selectedTeacherAreas.forEach((teacherSubject) => {
                subjects.push({
                    id: teacherSubject.userSubject.subject,
                    name: teacherSubject.userSubject.name,
                    type: 'teacher',
                    original: teacherSubject.userSubject,
                });
            });
        }
        if (this.selectedAreas) {
            this.selectedAreas.forEach((normalSubject) => {
                subjects.push({
                    id: normalSubject.id,
                    name: normalSubject.name,
                    type: 'normal',
                    original: normalSubject,
                });
            });
        }
        const uniqueSubjects = [];
        subjects.forEach((subject) => {
            if (uniqueSubjects.find((newSubject) => {
                return newSubject.id === subject.id;
            })) {
                return;
            }
            uniqueSubjects.push(subject);
        });
        return uniqueSubjects;
    }
    get selectedRoom() {
        if (Array.isArray(this.tableSelectedRoom) && this.tableSelectedRoom.length > 0) {
            return this.tableSelectedRoom[0];
        }
        if (typeof this.tableSelectedRoom === 'string') {
            return null;
        }
        if (typeof this.tableSelectedRoom === 'object' && this.tableSelectedRoom.length) {
            return this.tableSelectedRoom;
        }
        return this.event && this.event.room ? this.event.room : null;
    }
    get weekDays() {
        return [
            {
                key: '1',
                title: this.$t('weekDays.monday').toString(),
            },
            {
                key: '2',
                title: this.$t('weekDays.tuesday').toString(),
            },
            {
                key: '3',
                title: this.$t('weekDays.wednesday').toString(),
            },
            {
                key: '4',
                title: this.$t('weekDays.thursday').toString(),
            },
            {
                key: '5',
                title: this.$t('weekDays.friday').toString(),
            },
            {
                key: '6',
                title: this.$t('weekDays.saturday').toString(),
            },
            {
                key: '7',
                title: this.$t('weekDays.sunday').toString(),
            },
        ];
    }
    get formattedDatetimeSlotDay() {
        if (!this.datetimeslot) {
            return;
        }
        const weekDay = this.weekDays.find((weekDay) => {
            return weekDay.key == DateTime.fromSQL(this.datetimeslot.starts_at || '').toFormat('c');
        });
        return weekDay ? weekDay.title.charAt(0).toUpperCase() + weekDay.title.slice(1) : '-';
    }
    get filteredDatetimeslots() {
        if (!this.datetimeslot) {
            return [];
        }
        const startDatetimeslot = this.event && this.event.datetimeslots && this.event.datetimeslots[0] ? this.event.datetimeslots[0] : this.datetimeslot;
        let filteredDatetimeslots = [];
        const day = DateTime.fromSQL(this.datetimeslot.starts_at || '').weekday;
        this.datetimeslots.forEach((slot) => {
            const filterDay = DateTime.fromSQL(slot.starts_at || '').weekday;
            if (filterDay === day) {
                filteredDatetimeslots.push(slot);
            }
        });
        filteredDatetimeslots = filteredDatetimeslots.filter((slot) => {
            if (slot.id === this.selectedDoublePeriodDatetimeslot && startDatetimeslot.id !== slot.id) {
                return true;
            }
            if (slot.starts_at && startDatetimeslot.ends_at) {
                const startTime = DateTime.fromSQL(slot.starts_at || '').toFormat('HH:mm:ss');
                const endTime = DateTime.fromSQL(startDatetimeslot.ends_at || '').toFormat('HH:mm:ss');
                return startTime >= endTime;
            }
        });
        return filteredDatetimeslots.sort(sortByKey('starts_at'));
    }
    get selectedDatetimeslots() {
        const datetimeslots = [];
        let datetimeslotFound = false;
        if (!this.isDoublePeriod && this.datetimeslot.id) {
            return [this.datetimeslot.id];
        }
        if (!this.selectedDoublePeriodDatetimeslot && this.datetimeslot.id) {
            return [this.datetimeslot.id];
        }
        const possibleTimeslots = this.datetimeslots.sort(sortByKey('starts_at'));
        possibleTimeslots.forEach((datetimeslot) => {
            if (datetimeslotFound || !datetimeslot.id) {
                return;
            }
            const firstTimeslotStartsAt = DateTime.fromSQL(this.firstDatetimeslot.starts_at).toFormat('HH:mm:ss');
            const currentTimeslotStartsAt = DateTime.fromSQL(datetimeslot.starts_at).toFormat('HH:mm:ss');
            if (currentTimeslotStartsAt < firstTimeslotStartsAt) {
                return;
            }
            datetimeslots.push(datetimeslot.id);
            if (datetimeslot.id === this.selectedDoublePeriodDatetimeslot) {
                datetimeslotFound = true;
            }
        });
        return datetimeslots;
    }
    get firstDatetimeslot() {
        if (this.event && this.event.datetimeslots && this.event.datetimeslots.length > 0) {
            const datetimeslots = this.event.datetimeslots.sort(sortByKey('starts_at'));
            return datetimeslots[0];
        }
        if (this.datetimeslot) {
            return this.datetimeslot;
        }
        return this.findDatetimeslotById(this.selectedDatetimeslots[0]);
    }
    get lastDatetimeslot() {
        const lastDatetimeslotIndex = this.selectedDatetimeslots.length - 1;
        return this.findDatetimeslotById(this.selectedDatetimeslots[lastDatetimeslotIndex]);
    }
    get whiteIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    mounted() {
        this.initialize();
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    findAreaId(id) {
        return this.selectedAreas.findIndex((subject) => subject.id === id);
    }
    findTeacherAreaId(id) {
        return this.selectedTeacherAreaId.findIndex((id) => id === id);
    }
    findTopicId(id) {
        return this.selectedTopics.findIndex((topic) => topic.id === id);
    }
    findLevelId(id) {
        return this.selectedLevels.findIndex((level) => level.id === id);
    }
    findGroupId(id) {
        return this.selectedGroups.findIndex((group) => group.id === id);
    }
    parseToTeacherSubject(subjects) {
        const areas = this.$store.state.curriculum.subjects;
        subjects.forEach((userSubject) => {
            const area = areas.find((subject) => {
                return subject.id === userSubject.subject;
            });
            const teacherSubject = {
                id: userSubject.subject,
                name: userSubject.name,
                color: area.color || '',
                userSubject,
                isEditing: false,
            };
            this.teacherSubjects.push(teacherSubject);
        });
    }
    create() {
        const payload = this.createPayload();
        new EventModel()
            .create(payload)
            .then(() => {
            this.isLoading = false;
            this.currentStep = 7;
            this.$emit('eventCreated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    close() {
        this.$emit('input', false);
        this.clearSelects = false;
        this.currentStep = 1;
    }
    clear() {
        this.clearSelects = true;
        this.selectedTeachers = [];
        this.selectedAreas = [];
        this.selectedTopics = [];
        this.tableSelectedRoom = '';
        this.selectedLevels = [];
        this.selectedGroups = [];
        this.teacherSubjects = [];
        this.userSubjects = [];
        this.isMandatoryLevels = false;
        this.isMandatoryGroups = false;
        this.$nextTick(() => {
            this.close();
        });
    }
    eventChanged(event) {
        if (event) {
            this.fillSelected();
        }
    }
    areaSelected() {
        this.emptyTeacherSubjectValues();
        if (this.currentStep === 2) {
            this.selectedTopics = [];
        }
    }
    teacherAreaSelected() {
        if (this.currentStep === 2) {
            this.selectedTopics = [];
        }
    }
    changedTeacherAreaId() {
        this.setTeacherSubject();
    }
    currentStepChanged() {
        if (this.currentStep === 2 && this.selectedTeacherAreas.length === 0) {
            this.fetchUserSubject();
        }
        if (this.currentStep === 5) {
            this.roomSize();
        }
    }
    findDatetimeslotById(datetimeslotId) {
        const datetimeslot = this.datetimeslots.find((datetimeslot) => {
            return datetimeslot.id === datetimeslotId;
        });
        return datetimeslot || null;
    }
    initialize() {
        this.isLoading = true;
        if (!this.eventId) {
            this.isLoading = false;
            return;
        }
        (new EventModel).include(['areas', 'topics', 'groups', 'levels', 'meta', 'room', 'subjects', 'teacher', 'users', 'datetimeslots', 'roles']).find(this.eventId).then((event) => {
            this.event = event;
            this.fillSelected();
            const totalDateTimeslots = this.event && this.event.datetimeslots ? this.event.datetimeslots.length : 0;
            if (totalDateTimeslots > 1) {
                this.isDoublePeriod = true;
                this.selectedDoublePeriodDatetimeslot = this.event.datetimeslots[totalDateTimeslots - 1].id;
            }
            this.isLoading = false;
            this.currentStep = 6;
        });
    }
    deleteArea(subject) {
        if (subject && subject.id) {
            const index = this.findAreaId(subject.id);
            this.selectedAreas.splice(index, 1);
        }
        this.selectedTopics = [];
    }
    deleteTopic(topic) {
        if (topic && topic.id) {
            const index = this.findTopicId(topic.id);
            this.selectedTopics.splice(index, 1);
        }
    }
    deleteTeacherArea(userSubject) {
        if (userSubject && userSubject.id) {
            const index = this.selectedTeacherAreas.findIndex((currentSubject) => {
                return currentSubject.userSubject.id === userSubject.id;
            });
            if (index >= 0) {
                this.selectedTeacherAreas.splice(index, 1);
            }
        }
        this.selectedTeacherAreaId = [];
        this.selectedTeacherAreas = [];
        this.selectedTopics = [];
    }
    deleteLevel(level) {
        if (level && level.id) {
            const index = this.findLevelId(level.id);
            this.selectedLevels.splice(index, 1);
        }
    }
    deleteGroup(group) {
        if (group && group.id) {
            const index = this.findGroupId(group.id);
            this.selectedGroups.splice(index, 1);
        }
    }
    fetchUserSubject() {
        this.teacherSubjects = [];
        this.selectedTeachers.forEach((selected) => {
            new UserSubject()
                .user(selected.id || '')
                .all()
                .then((teacherSubjects) => {
                this.parseToTeacherSubject(teacherSubjects);
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    roomSize() {
        let totalUsers = [];
        this.selectedGroups.forEach((group) => {
            if (group.users) {
                const groupUsers = group.users
                    .filter((user) => {
                    const userModel = new DataModel().dataToModel(user, 'User');
                    return userModel.hasRole([RolesEnum.STUDENT]);
                }).map((user) => {
                    return user.id;
                });
                totalUsers = [...totalUsers, ...groupUsers];
            }
        });
        this.selectedLevels.map((level) => {
            if (level.users) {
                const levelUsers = level.users
                    .filter((user) => {
                    const userModel = new DataModel().dataToModel(user, 'User');
                    return userModel.hasRole([RolesEnum.STUDENT]);
                }).map((user) => {
                    return user.id;
                });
                totalUsers = [...totalUsers, ...levelUsers];
            }
        });
        const uniqueUsers = [...new Set(totalUsers)];
        const capacity = this.tableSelectedRoom.capacity;
        capacity && parseInt(capacity) < uniqueUsers.length ? this.isRoomFull = true : this.isRoomFull = false;
    }
    setSelectedTeacherAreas(subjects) {
        const areas = this.$store.state.curriculum.subjects;
        subjects.forEach((userSubject) => {
            const area = areas.find((subject) => {
                return subject.id === userSubject.subject;
            });
            const teacherSubjects = [];
            const teacherSubject = {
                id: userSubject.id,
                name: userSubject.name,
                color: area.color || '',
                userSubject,
                isEditing: false,
                icon: userSubject.icon,
            };
            teacherSubjects.push(teacherSubject);
            this.selectedAreas = [];
            this.selectedTeacherAreaId = teacherSubjects.map((teacherSubject) => {
                return teacherSubject.id || '';
            });
        });
    }
    setTeacherSubject() {
        if (this.selectedTeacherAreaId && this.selectedTeacherAreaId.length) {
            if (this.selectedTeacherAreaId.length > 1) {
                const index = this.findTeacherAreaId(this.selectedTeacherAreaId[0]);
                this.selectedTeacherAreaId.splice(index, 1);
            }
            if (this.selectedAreas.length) {
                const index = this.findAreaId(this.selectedAreas[0].id);
                this.selectedAreas.splice(index, 1);
            }
            const match = this.teacherSubjects.find((subject) => {
                return subject.id === this.selectedTeacherAreaId[0];
            });
            if (match && this.selectedTeacherAreas.length > 0) {
                const index = this.findTeacherAreaId(this.selectedTeacherAreas[0]);
                this.selectedTeacherAreas.splice(index, 1);
            }
            this.selectedTeacherAreas.push(match);
        }
    }
    emptyTeacherSubjectValues() {
        if (this.selectedAreas && this.selectedAreas.length) {
            this.selectedTeacherAreaId = [];
            this.selectedTeacherAreas = [];
        }
    }
    createOrUpdate() {
        this.isLoading = true;
        if (this.event) {
            this.update();
        }
        else {
            this.create();
        }
    }
    update() {
        const payload = this.createPayload();
        payload.validate = false;
        if (!this.event) {
            return false;
        }
        this.event
            .put(payload)
            .then(() => {
            this.isLoading = false;
            this.currentStep = 7;
            this.$emit('eventUpdated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    createPayload() {
        const areas = [
            ...new Set([
                ...this.selectedTeacherAreas.map((subject) => {
                    if (subject.userSubject) {
                        return subject.userSubject.subject;
                    }
                }),
                ...this.selectedAreas.map((subject) => {
                    return subject.id;
                }),
            ]),
        ];
        return {
            datetimeslots: this.selectedDatetimeslots,
            type: 'lesson',
            teacher: this.selectedTeachers.map((teacher) => {
                return {
                    id: teacher.id,
                    is_mandatory: true,
                };
            }),
            room: this.selectedRoom.id,
            areas,
            topics: this.selectedTopics.map((topic) => {
                return topic.id;
            }),
            levels: this.selectedLevels.map((level) => {
                return {
                    id: level.id,
                    is_mandatory: this.isMandatoryLevels,
                };
            }),
            groups: this.selectedGroups.map((group) => {
                return {
                    id: group.id,
                    is_mandatory: this.isMandatoryGroups,
                };
            }),
            validate: false,
            is_volitional_subjects_finished: false,
            is_volitional_subjects_unknown: false,
            is_volitional_subjects_active: false,
        };
    }
    fillSelected() {
        if (!this.event) {
            return;
        }
        this.selectedGroups = this.event.groups || [];
        this.selectedLevels = this.event.levels || [];
        this.tableSelectedRoom = this.event.room || new Room();
        this.selectedAreas = this.event.areas || [];
        this.selectedTopics = this.event.topics || [];
        this.selectedTeachers = this.event.teacher ? [this.event.teacher] : [];
        this.selectedGroups.forEach((group) => {
            if (group.is_mandatory) {
                this.isMandatoryGroups = true;
            }
        });
        this.selectedLevels.forEach((level) => {
            if (level.is_mandatory) {
                this.isMandatoryLevels = true;
            }
        });
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof DateTimeslot !== "undefined" && DateTimeslot) === "function" ? _a : Object)
], CreateEventDialog.prototype, "datetimeslot", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], CreateEventDialog.prototype, "datetimeslots", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], CreateEventDialog.prototype, "eventId", void 0);
__decorate([
    Watch('event'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof EventModel !== "undefined" && EventModel) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], CreateEventDialog.prototype, "eventChanged", null);
__decorate([
    Watch('selectedAreas'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateEventDialog.prototype, "areaSelected", null);
__decorate([
    Watch('selectedTeacherAreas'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateEventDialog.prototype, "teacherAreaSelected", null);
__decorate([
    Watch('selectedTeacherAreaId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateEventDialog.prototype, "changedTeacherAreaId", null);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateEventDialog.prototype, "currentStepChanged", null);
CreateEventDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
            DataTable,
        },
        filters: {
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
        },
    })
], CreateEventDialog);
export default CreateEventDialog;
